export const ADD_OPEN_BET = 'ADD_OPEN_BET';
export const TOOGLE_EW_BET = 'TOOGLE_EW_BET';
export const REMOVE_OPEN_BET = 'REMOVE_OPEN_BET';
export const UPDATE_OPEN_BET_STAKE = 'UPDATE_OPEN_BET_STAKE';
export const CLEAR_OPEN_BETS_LIST = 'CLEAR_OPEN_BETS_LIST';
export const REMOVE_CLOSED_EVENTS_OPEN_BETS = 'REMOVE_CLOSED_EVENTS_OPEN_BETS';

export const TOGGLE_COMMIT_BETS_SUCCESS = 'TOGGLE_COMMIT_BETS_SUCCESS';
export const TOGGLE_COMMIT_BETS_ERROR = 'TOGGLE_COMMIT_BETS_ERROR';
export const TOGGLE_COMMITTING_BETS = 'TOGGLE_COMMITTING_BETS';

export const OPEN_BET_HISTORY = 'OPEN_BET_HISTORY';
export const CLOSE_BET_HISTORY = 'CLOSE_BET_HISTORY';

export const ADD_LOCAL_STORED_BETS = 'ADD_LOCAL_STORED_BETS';

export const TOGGLE_FILTER_WINS_BET_HISTORY = 'TOGGLE_FILTER_WINS_BET_HISTORY';
export const TOGGLE_FILTER_WINS_SETTLED_BETS = 'TOGGLE_FILTER_WINS_SETTLED_BETS';
export const SET_BET_SLIP_CONTAINER_HEIGHT = 'SET_BET_SLIP_CONTAINER_HEIGHT';

export const UPDATE_OPEN_BET_MULTIPLIER = 'UPDATE_OPEN_BET_MULTIPLIER';

export const DO_QUICK_FILL_BETS = 'DO_QUICK_FILL_BETS';
export const TOGGLE_QUICK_FILL = 'TOGGLE_QUICK_FILL';
export const DISABLE_QUICK_FILL = 'DISABLE_QUICK_FILL';
export const AUTO_FOCUS_QUICK_FILL = 'AUTO_FOCUS_QUICK_FILL';

export const APPLY_PROMO_BET = 'APPLY_PROMO_BET';
export const SELECTED_BET = 'SELECTED_BET'
export const REMOVE_PROMO_BET = 'REMOVE_PROMO_BET'



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/constants/actionTypes.js